<template>
  <div class="view achievement-view">
    <HeaderBar />
    <div class="chart-wrap">
      <div class="title-wrap">
        <span class="title">总学习数量</span>
        <span>{{ `${count}个` }}</span>
      </div>
      <ve-histogram :data="chartData" height="208px"></ve-histogram>
      
    </div>
    <van-tabs v-model="active" swipeable @change="onActiveChange">
        <van-tab title="文章">
          <div class="news-list">
            <NewsItem v-for="item in newsList" :key="item.id" v-bind="item" />
          </div>
        </van-tab>
        <van-tab title="智库">
          <div class="news-list">
            <DigitalItem
              v-for="item in digitalList"
              :key="item.id"
              v-bind="item"
            />
          </div>
        </van-tab>
        <van-tab title="课程">
          <div class="news-list">
            <CourseItem
              v-for="item in cousrseList"
              :key="item.id"
              v-bind="item"
            />
          </div>
        </van-tab>
      </van-tabs>
  </div>
</template>

<script>
import { Tabs, Tab } from 'vant';
import VeHistogram from 'v-charts/lib/histogram.common';
import HeaderBar from '../../components/HeaderBar';
import NewsItem from '../../components/NewsItem';
import CourseItem from '../../components/CourseItem';
import DigitalItem from '../../components/DigitalItem';
import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
export default {
  name: 'achievement',
  components: {
    'van-tabs': Tabs,
    'van-tab': Tab,
    've-histogram': VeHistogram,
    HeaderBar,
    NewsItem,
    DigitalItem,
    CourseItem
  },
  data() {
    return {
      count: 0,
      chartData: {},
      active: 0,
      newsList: [],
      digitalList: [],
      cousrseList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getChartData();
      this.getRecent();
    },

    async getChartData() {
      const res = await apiUtil.post(apiConst.getAchievement);
      if (res.success) {
        const { count, xy_data } = res;
        this.count = count;
        const rows = xy_data.map((ele, index) => {
          return {
            月份: index + 1,
            智库: ele.video,
            课程: ele.courseware,
            文章: ele.article
          };
        });
        this.chartData = {
          columns: ['月份', '智库', '课程', '文章'],
          rows
        };
      }
    },

    async getRecent(type = 1) {
      const res = await apiUtil.post(apiConst.getRecent, { type });
      if (res.success) {
        if (type === 1) {
          this.newsList = res.list;
        } else if (type === 2) {
          this.digitalList = res.list;
        } else if (type === 3) {
          this.cousrseList = res.list;
        } else return;
      }
    },

    onActiveChange(index, title) {
      this.getRecent(index + 1);
    }
  }
};
</script>

<style lang="stylus" scoped>
.achievement-view {
  .chart-wrap {
    height: 396px;
    border: 15px solid #F1F1F1;

    .title-wrap {
      height: 75px
      padding 0 28px 0 50px
      display: flex;
      align-items center
      justify-content space-between
    }
  }

  .news-list{
    padding: 20px 15px;
  }
}
</style>
